import ApiService from "@/common/general-api";
import JwtService from "@/common/general-jwt";



/** ----------------------------------------------------
 * State => Holds all data we need
 ----------------------------------------------------- */
const state = {};



/** ----------------------------------------------------
 * Mutations => Updates data in State
 ----------------------------------------------------- */
const mutations = {};



/** ----------------------------------------------------
 * Actions => Proccess and fetch data
 ----------------------------------------------------- */
const actions = {
	
	/**
	 * Proccess Vote
	 * @param {*} context 
	 * @param {object} params 
	 */
	feedback_vote( context, {feedback_id, vote} ) {
		
		// call api to get feedback items
		return new Promise( function(resolve, reject) {

            // update feedback via api
            ApiService.post('feedback/' + context.getters.product_active_id + '/item/' + feedback_id + '/vote/', vote, function( data ) {

                // get single product
                context.dispatch( 'feedback_item_load', {feedback_id: feedback_id, force: true} );

                // set success
                return resolve(data);

            }, function( data ) {

                // set rejection
                return reject(data);

            });

        });

	}

};



/** ----------------------------------------------------
 * Getters => Access data from outside
 ----------------------------------------------------- */
const getters = {};



/***********************
 * Export
***********************/

export default {
	state,
	getters,
	actions,
	mutations
};